import { EditableText, defineBlock } from "eddev/blocks"
import { HomePagesNavigation } from "@components/atoms/HomePagesNavigation"
import { twMerge } from "tailwind-merge"

export const meta: BlockMeta = {
  title: "Home Intro",
  category: "common",
  icon: "chart-bar",
  keywords: ["intro"],
  tags: ["root"],
  editMode: "preview",
  conditions: {
    postTypes: ["page", "post"],
    multiple: false,
  },
}

export default defineBlock("home/home-intro", (props) => {
  return (
    <div className="w-full flex flex-col gap-6">
      <div className="grid-auto my-[40px] md:mb-0">
        <div
          className={twMerge(
            "col-span-12 flex items-center justify-center",
            !env.admin && "md:col-span-10 md:col-start-2 xxl:col-span-8 xxl:col-start-3",
          )}
        >
          <EditableText as="h1" className="!type-title-l !text-center mb-5" store="title" placeholder="Enter title" />
        </div>
      </div>

      <HomePagesNavigation />
    </div>
  )
})
